export class TypeMotsClef {

	public motClef: string[];

	constructor() { 
		this.motClef = [];
	}
}
